module.exports = __webpack_public_path__ + "img/saint-barthélemy.4c57c182.svg";